import { useTranslation } from 'react-i18next'

import { MapPinIcon, PencilSimpleIcon } from '@phosphor-icons/react'

import { Button } from '@reveni-io/reveni-ui'

import { selectDropOffPointTitle } from '../constants'
import { supportsDropOffPointSelection } from '../helpers'
import Heading from './Heading/Heading'
import SelectedDropOffPoint from './SelectedDropOffPoint/SelectedDropOffPoint'
import {
  buttonVariants,
  dropOffPointTitle,
  editDropOffPoint,
  editDropOffPointExplanation,
  selectDropOffPointExplanation,
  yourDropOffPointTitle,
} from './constants'
import * as Styles from './styles'

const DropOffPointSelector = ({ deliveryMethod, selectedDropOffPoint, onOpen }) => {
  const { t } = useTranslation()

  const title = selectedDropOffPoint ? yourDropOffPointTitle : dropOffPointTitle
  const explanation = selectedDropOffPoint ? editDropOffPointExplanation : selectDropOffPointExplanation
  const buttonLabel = selectedDropOffPoint ? editDropOffPoint : selectDropOffPointTitle
  const buttonVariant = selectedDropOffPoint ? buttonVariants.outlined : buttonVariants.contained
  const ButtonIcon = selectedDropOffPoint ? PencilSimpleIcon : MapPinIcon

  if (!supportsDropOffPointSelection(deliveryMethod)) return null

  return (
    <Styles.Container>
      <Heading title={title} explanation={explanation} />
      {selectedDropOffPoint && (
        <SelectedDropOffPoint dropOffPoint={selectedDropOffPoint} carrier={deliveryMethod.carrier_service} />
      )}
      <Button onClick={onOpen} variant={buttonVariant} fullWidth>
        <ButtonIcon size={24} weight="regular" />
        {t(buttonLabel)}
      </Button>
    </Styles.Container>
  )
}

export default DropOffPointSelector
